import { useQuery } from '@tanstack/react-query';
import { DefaultApiResponse, SubscriptionPlanApiService } from '@waitroom/common-api';
import { getPlansQuery, QueryOptions } from '@waitroom/react-query';

export type UseGetPlansProps = QueryOptions<
  SubscriptionPlanApiService.GetPlans['response'] | undefined,
  DefaultApiResponse
>;

export const useGetPlans = (options?: UseGetPlansProps) =>
  useQuery({
    ...getPlansQuery(),
    ...options,
  });
